"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const commonAbis = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "owner",
    type: "address"
  }, {
    indexed: true,
    name: "spender",
    type: "address"
  }, {
    indexed: false,
    name: "value",
    type: "uint256"
  }],
  name: "Approval",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "from",
    type: "address"
  }, {
    indexed: true,
    name: "to",
    type: "address"
  }, {
    indexed: false,
    name: "value",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "_from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "_to",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}];
var _default = exports.default = commonAbis;
//# sourceMappingURL=common-abis.js.map